import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'

export default class HoleControllerService {
    static async save(orderId, detailId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/holes${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId, detailId, holeId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/details/${detailId}/holes/${holeId}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(orderId, detailId, holeId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/holes/${holeId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
